import React, { lazy } from 'react';
import { GiftIcon, LockIcon, ArrowRightIcon, ZapIcon, RefreshCwIcon, StarIcon, CheckCircleIcon } from 'lucide-react';
import { useGeoPricingContext } from '../hooks/GeoPricingContext';
export function BonusSection() {
  const {
    newPrice,
    totalValue
  } = useGeoPricingContext();
  const bonuses = [{
    title: 'BONUS #1. GUÍA PRÁCTICA',
    subtitle: 'PRÁCTICA SIN RIESGO',
    desc: 'Aprende sin riesgo con ejercicios reales de comandos eléctricos.',
    value: '60 USD',
    image: 'https://cdn.magicpatterns.com/uploads/1SPjiFgDMADf7JeXTftUFp/BONO_1.webp'
  }, {
    title: 'BONUS #2. PLANTILLA DE PRESUPUESTOS',
    subtitle: 'PRESUPUESTOS PROFESIONALES',
    desc: 'Deja de trabajar a ciegas y cobra con criterio profesional.',
    value: '65 USD',
    image: 'https://cdn.magicpatterns.com/uploads/9mJsUE1zC8vK44NG255Ztd/bono_2.webp'
  }, {
    title: 'BONUS #3. HOJA DE MOTORES',
    subtitle: 'CÁLCULOS PRECISOS',
    desc: 'Evita errores técnicos y mejora tu precisión en cada proyecto.',
    value: '40 USD',
    image: 'https://cdn.magicpatterns.com/uploads/eS9N3Tw6YDHZShwWi2QVQM/bono_3.webp'
  }, {
    title: 'BONUS #4. CONTROL DE INGRESOS',
    subtitle: 'CONTROL FINANCIERO',
    desc: 'Organiza tu dinero como un profesional independiente.',
    value: '35 USD',
    image: 'https://cdn.magicpatterns.com/uploads/6CronRBQ32z2E9GFRJFFmE/bono-4.webp'
  }, {
    title: 'BONUS #5. CERTIFICADO PROFESIONAL',
    subtitle: 'CERTIFICACIÓN OFICIAL',
    desc: 'Respalda tu conocimiento con un certificado profesional.',
    value: '38 USD',
    image: 'https://cdn.magicpatterns.com/uploads/vDD48ETKcAwPNhC8CakPNy/bono-5.webp'
  }];
  return <section className="bg-cream py-10 px-4" data-id="element-61">
      <div className="max-w-[900px] mx-auto" data-id="element-62">
        <div className="text-center mb-8" data-id="element-63">
          <h2 className="text-[28px] md:text-[32px] font-bold text-brand-black mb-2 leading-[1.2] flex items-center justify-center gap-3" data-id="element-64">
            <GiftIcon className="w-8 h-8 text-primary" data-id="element-65" />
            SOLO POR HOY
          </h2>
          <p className="text-[22px] md:text-[26px] font-black text-primary uppercase tracking-wide mb-4" data-id="element-66">
            ¡LLÉVATE 5 BONUS GRATIS!
          </p>
        </div>

        {/* Bonus Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-10" data-id="element-67">
          {bonuses.map((bonus, idx) => <div key={idx} className="flex flex-col items-center text-center" data-id="element-68">
              {/* Header */}
              <h3 className="text-primary font-bold uppercase tracking-wide text-lg mb-2" data-id="element-69">
                {bonus.title}
              </h3>

              {/* Value Row */}
              <div className="flex items-center justify-center gap-3 mb-6" data-id="element-70">
                <span className="text-danger font-bold text-sm" data-id="element-71">
                  Valor: <span className="line-through" data-id="element-72">{bonus.value}</span>
                </span>
                <span className="bg-brand-black text-primary border border-primary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-73">
                  GRATIS HOY
                </span>
              </div>

              {/* 3D Book Image */}
              <div className="mb-6 relative w-[220px] h-[300px] mx-auto" data-id="element-74">
                <img loading="lazy" src={bonus.image} alt={bonus.subtitle} className="w-full h-full object-contain drop-shadow-2xl" width="220" height="300" data-id="element-75" />
              </div>

              {/* Text Content */}
              <h4 className="text-brand-black font-bold text-lg mb-2 uppercase" data-id="element-76">
                {bonus.subtitle}
              </h4>
              <p className="text-dark-gray text-sm leading-relaxed max-w-[300px]" data-id="element-77">
                {bonus.desc}
              </p>
            </div>)}
        </div>

        {/* Extra Bonus */}
        <div className="max-w-[600px] mx-auto mb-10" data-id="element-78">
          <div className="bg-brand-black-light border border-primary/50 rounded-xl p-6 shadow-gold flex flex-col sm:flex-row items-center sm:items-start gap-5 text-center sm:text-left relative overflow-hidden" data-id="element-79">
            <div className="absolute top-0 right-0 bg-primary text-brand-black text-[10px] font-bold px-4 py-1.5 rounded-bl-lg uppercase tracking-wider" data-id="element-80">
              Extra
            </div>
            <div className="flex-shrink-0 w-24 h-24" data-id="element-81">
              <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/a7XRsAYCsbJcGBXwtQU4TF/acceso-de-por-vida.webp" alt="Acceso de por vida" className="w-full h-full object-contain drop-shadow-lg" width="96" height="96" data-id="element-82" />
            </div>
            <div className="flex-grow" data-id="element-83">
              <h3 className="text-xl font-bold text-primary mb-2 uppercase" data-id="element-84">
                Bonus Extra — Acceso de por Vida
              </h3>
              <p className="text-base text-dark-gray mb-3" data-id="element-85">
                Actualizaciones incluidas sin pagar más. Todo el contenido nuevo
                será tuyo gratis.
              </p>
              <div className="flex items-center justify-center sm:justify-start gap-3" data-id="element-86">
                <span className="text-danger font-bold text-sm" data-id="element-87">
                  Valor: <span className="line-through" data-id="element-88">50+ USD</span>
                </span>
                <span className="bg-brand-black text-primary border border-primary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-89">
                  GRATIS HOY
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Surprise Gifts Block */}
        <div className="text-center mx-auto p-8 rounded-xl bg-brand-black-light border border-white/10 shadow-medium max-w-[500px]" data-id="element-90">
          <div className="text-lg font-bold text-dark-gray mb-2 uppercase tracking-wider" data-id="element-91">
            VALOR TOTAL
          </div>
          <div className="text-[32px] font-bold line-through text-danger mb-6" data-id="element-92">
            {totalValue}
          </div>
          <div className="text-xl font-bold text-brand-black mb-2 uppercase tracking-wider" data-id="element-93">
            HOY OBTIENES TODO POR:
          </div>
          <div className="text-[64px] font-black text-primary font-poppins tracking-tight mb-6 leading-none" data-id="element-94">
            {newPrice}
          </div>

          <a href="https://dominaelcontrol.online/cart/50664044626153:1" onClick={() => window.fbq && window.fbq('track', 'AddToCart')} className="animate-pulse-big flex items-center justify-center gap-2 w-full bg-gradient-to-br from-success to-emerald-600 text-white border-none py-4 px-6 text-lg font-bold rounded-full cursor-pointer shadow-[0_8px_20px_rgba(34,197,94,0.3)] text-center uppercase tracking-wide no-underline hover:translate-y-[-3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(34,197,94,0.4)] transition-all duration-400" data-id="element-95">
            QUIERO TODO EL SISTEMA
            <ArrowRightIcon className="w-5 h-5" data-id="element-96" />
          </a>
          <div className="mt-5 inline-flex items-center gap-2 bg-red-600 text-white px-5 py-2.5 rounded-full font-bold text-sm shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-97">
            <span className="w-2.5 h-2.5 bg-white rounded-full animate-pulse" data-id="element-98"></span>
            ¡Últimos cupos disponibles!
          </div>

          {/* Trust Badges */}
          <div className="flex flex-col items-center gap-2 mt-6 text-sm text-dark-gray font-medium" data-id="element-99">
            <div className="flex items-center gap-3" data-id="element-100">
              <span className="flex items-center gap-1" data-id="element-101">
                <LockIcon className="w-4 h-4 text-primary" data-id="element-102" /> Garantía 7 Días
              </span>
              <span data-id="element-103">·</span>
              <span className="flex items-center gap-1" data-id="element-104">
                <ZapIcon className="w-4 h-4 text-primary" data-id="element-105" /> Acceso Inmediato
              </span>
            </div>
            <div className="flex items-center gap-1" data-id="element-106">
              <RefreshCwIcon className="w-4 h-4 text-primary" data-id="element-107" /> Actualizaciones
              diarias de por vida
            </div>
            <div className="bg-[#1A1D24] border border-white/10 rounded-full px-4 py-1.5 flex items-center gap-2 mt-1" data-id="element-108">
              <div className="flex text-primary" data-id="element-109">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-110" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-111" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-112" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-113" />
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-114" />
              </div>
              <span className="text-white font-bold text-xs" data-id="element-115">
                4.9/5{' '}
                <span className="text-dark-gray font-normal" data-id="element-116">
                  +2.554 Electricistas
                </span>
              </span>
              <CheckCircleIcon className="w-4 h-4 text-blue-500 fill-white" data-id="element-117" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}